import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common'
import { EventEmitterService } from 'services/event-emitter.service';
import { ProspectService } from 'services/prospect.service';
import { Router } from '@angular/router';
import { ProspectConfirm } from 'app/models/prospect-confirm';
import { CompressionService } from 'services/compression.service';
import { ErrorService } from 'services/error.service';
import { SplashService } from 'services/splash.service';
import { LabelValue } from 'app/models/labelvalue';

@Component({
  selector: 'app-confirm-info',
  templateUrl: './confirm-info.component.html',
  styleUrls: ['./confirm-info.component.css']
})
export class ConfirmInfoComponent implements OnInit {
  dlFile: File = null;
  errorMessage: String = null;
  states: LabelValue[] = [];
  model: ProspectConfirm = new ProspectConfirm();
  yardiKey: string = null;
  isLoading: boolean
  getConfirmInfoCount: number = 0;

  constructor(private eventEmitterService: EventEmitterService, private prospectService: ProspectService, public router: Router, private compressionService: CompressionService, private errorService: ErrorService, private splashService: SplashService, private location: Location) {
    this.eventEmitterService.selfTourStepChange(2);

    let yardiKey = localStorage.getItem('YardiID');

    if (yardiKey !== null && yardiKey !== undefined) {
      this.yardiKey = yardiKey;
    }
  }

  ngOnInit() {
    this.isLoading = true;
    this.prospectService.GetSelfTourConfirmInfo(null).subscribe(res => this.onGetSelfTourConfirmInfo(res), res => this.errorService.showError(res));
    this.getStates();
    this.splashService.updateSplash("selftour");
  }

  getStates() {
    this.states.push({ label: 'AK', value: 'AK' });
    this.states.push({ label: 'AL', value: 'AL' });
    this.states.push({ label: 'AR', value: 'AR' });
    this.states.push({ label: 'AZ', value: 'AZ' });
    this.states.push({ label: 'CA', value: 'CA' });
    this.states.push({ label: 'CO', value: 'CO' });
    this.states.push({ label: 'CT', value: 'CT' });
    this.states.push({ label: 'DE', value: 'DE' });
    this.states.push({ label: 'FL', value: 'FL' });
    this.states.push({ label: 'GA', value: 'GA' });

    this.states.push({ label: 'HI', value: 'HI' });
    this.states.push({ label: 'IA', value: 'IA' });
    this.states.push({ label: 'ID', value: 'ID' });
    this.states.push({ label: 'IL', value: 'IL' });
    this.states.push({ label: 'IN', value: 'IN' });
    this.states.push({ label: 'KS', value: 'KS' });
    this.states.push({ label: 'KY', value: 'KY' });
    this.states.push({ label: 'LA', value: 'LA' });
    this.states.push({ label: 'MA', value: 'MA' });
    this.states.push({ label: 'MD', value: 'MD' });

    this.states.push({ label: 'ME', value: 'ME' });
    this.states.push({ label: 'MI', value: 'MI' });
    this.states.push({ label: 'MN', value: 'MN' });
    this.states.push({ label: 'MO', value: 'MO' });
    this.states.push({ label: 'MS', value: 'MS' });
    this.states.push({ label: 'MT', value: 'MT' });
    this.states.push({ label: 'NE', value: 'NE' });
    this.states.push({ label: 'NH', value: 'NH' });
    this.states.push({ label: 'NJ', value: 'NJ' });
    this.states.push({ label: 'NM', value: 'NM' });

    this.states.push({ label: 'NV', value: 'NV' });
    this.states.push({ label: 'NY', value: 'NY' });
    this.states.push({ label: 'NC', value: 'NC' });
    this.states.push({ label: 'ND', value: 'ND' });
    this.states.push({ label: 'OH', value: 'OH' });
    this.states.push({ label: 'OK', value: 'OK' });
    this.states.push({ label: 'OR', value: 'OR' });
    this.states.push({ label: 'PA', value: 'PA' });
    this.states.push({ label: 'RI', value: 'RI' });
    this.states.push({ label: 'SC', value: 'SC' });

    this.states.push({ label: 'SD', value: 'SD' });
    this.states.push({ label: 'TN', value: 'TN' });
    this.states.push({ label: 'TX', value: 'TX' });
    this.states.push({ label: 'UT', value: 'UT' });
    this.states.push({ label: 'VT', value: 'VT' });
    this.states.push({ label: 'VA', value: 'VA' });
    this.states.push({ label: 'WA', value: 'WA' });
    this.states.push({ label: 'WI', value: 'WI' });
    this.states.push({ label: 'WV', value: 'WV' });
    this.states.push({ label: 'WY', value: 'WY' });
  }

  onGetSelfTourConfirmInfo(info: ProspectConfirm) {

    /* The process of storing OCR data from the webhook takes long enough that the data isn't immediately available when 
       we load this confirmation page. Calling the endpoint recursively until we get it back. If we have to call it more than 25
       times, there is most likely an issue and we should stop calling and produce an error message. Local testing has shown that it can
       take up to 9 calls before it was retireved. */
    this.model = info;
    if (this.model.DateOfBirth !== null && this.model.DateOfBirth !== undefined) {
      this.model.DateOfBirth = this.prospectService.convertToLocalJSDate(this.model.DateOfBirth);
    }

    if (this.model.LicenseExpiration !== null && this.model.LicenseExpiration !== undefined) {
      this.model.LicenseExpiration = this.prospectService.convertToLocalJSDate(this.model.LicenseExpiration);
    }

    this.getConfirmInfoCount++;
    if (Object.keys(this.model).length === 0 && this.getConfirmInfoCount < 25) {
      this.prospectService.GetSelfTourConfirmInfo(null).subscribe(res => this.onGetSelfTourConfirmInfo(res), res => this.errorService.showError(res));
    } else if (this.getConfirmInfoCount >= 25){
      this.isLoading = false;
      this.errorService.showError("Error retrieving identity information.");
    }
    else {
      this.isLoading = false;
    }
  }

  submit() {
    var expiration = this.prospectService.convertToUTC(this.model.LicenseExpiration);
    var dob = this.prospectService.convertToUTC(this.model.DateOfBirth);
    const copyConfirmModel = {
      ...this.model,
      DateOfBirth : dob,
      LicenseExpiration : expiration
    };

    this.prospectService.UpdateSelfTourConfirmInfo(copyConfirmModel, null, false).subscribe(res => this.onSubmit(res), res => this.errorService.showError(res));
  }

  onSubmit(result: boolean) {
    if (result) {
      this.prospectService.CheckProspectStatus();
    }
    else {
      this.errorService.showError("Error updating information.");
    }
  }

  deny() {
    this.prospectService.DenyOcrData(null).subscribe(res => this.onDeny(res), res => this.errorService.showError(res));
  }

  onDeny(result: boolean) {
    if (result) {
      this.location.back();
    }
    else {
      this.errorService.showError("Error denying OCR information.");
    }
  }

}
